import { Dispatch } from "redux";
import {
  ERROR_LOADING_JOIN_REQUESTS,
  GET_ALL_JOIN_REQUESTS,
  RESET_DATA,
  START_LOADING_JOIN_REQUESTS,
  STOP_LOADING_JOIN_REQUESTS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchJoinRequestMembersAction =
  (programId?: any) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_JOIN_REQUESTS });
    try {
      const currentState = getState();
      const params = generateQueryStringForUsers(
        currentState.Filters.joinRequestFilter
      );

      const query = appendProgramIdInParams(programId, params);

      const { data } = await apiLibrary.joinRequests.getAllJoinRequests(query);
      dispatch({
        type: GET_ALL_JOIN_REQUESTS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_JOIN_REQUESTS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_JOIN_REQUESTS });
      // dispatch(loadingState(false))
    }
  };
const appendProgramIdInParams = (programId: any, params: any) => {
  let updatedParams = { ...params };

  if (programId) {
    updatedParams.programId = programId.toString();
  }

  return updatedParams;
};
